import React from "react";
import { CommandBar, CommandButton, Stack } from '@fluentui/react';
import { t } from 'i18next';
import PropTypes from 'prop-types';
import MessageBox from '../../../Common/Message/MessageBox';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { __MessageTypes } from '../../../../common/Dictionaries';
import { useSelector } from 'react-redux';
import { isNullUndefinedOrEmpty } from '../../../../common/Helpers';

const MatrixToolbar = (props) => {
    const { _contractProps: listContractsProps } = useSelector((state) => state.maintainerScope);

    const { 
        inputParam_HandleSaveData = null,
        inputParam_HandleUploadData = null,
        inputParam_HandleExportData = null,
        inputParam_HandleAddRow = null,
        inputParam_Configuration = null,
        inputParam_ExternalExportTemplates = null,
        inputParam_CustomOpenPanel = null,

        showRequiredMessage = false,
    } = props; 

    const [messageConfig, setMessageConfig] = useState({
        message : t('data-lang-msg-completemissingdata'),
        messageType : __MessageTypes.WARNING,
        showMessage : true,
    });

    const itemsExportTemplate = [
        {
            key: 'download',
            text: t('data-lang-btn-downloadtemplate'),
            iconProps: { iconName: 'Download' },
            hidden: !inputParam_Configuration.buttons.showDownloadTemplate,
            onClick: () => {
                inputParam_HandleExportData && inputParam_HandleExportData(false)
            },
        }
    ];

    const items = [
        {
            key: 'new',
            text: t('data-lang-btn-uploadmasivedata'),
            iconProps: { iconName: 'Upload' },
            hidden: !inputParam_Configuration.buttons.showAddMasiveData,
            onClick: () => {
                inputParam_HandleUploadData && inputParam_HandleUploadData()
            },
        },
        {
            key: 'save',
            text: isNullUndefinedOrEmpty(inputParam_Configuration.buttons.saveAllDataText) ? t('data-lang-btn-savealldata') : inputParam_Configuration.buttons.saveAllDataText,
            iconProps: { iconName: 'Save' },
            hidden: !inputParam_Configuration.buttons.showSaveAllData,
            onClick: () => {
                inputParam_HandleSaveData && inputParam_HandleSaveData()
            },
        },
        {
            key: 'add',
            text: t('data-lang-btn-addnewitem'),
            iconProps: { iconName: 'Add' },
            hidden: !inputParam_Configuration.buttons.showAddData,
            onClick: () => {
                inputParam_HandleAddRow && inputParam_HandleAddRow(null, listContractsProps)
            },
        },
        {
            key: 'export',
            text: t('data-lang-btn-exportdata'),
            iconProps: { iconName: 'Export' },
            hidden: !inputParam_Configuration.buttons.showExportData,
            onClick: () => {
                inputParam_HandleExportData && inputParam_HandleExportData(true)
            },
        },{
            key: 'openPanel',
            text: t('data-lang-btn-configureprops'),
            iconProps: { iconName: 'Settings' },
            hidden: inputParam_CustomOpenPanel === null || inputParam_CustomOpenPanel === false,
            onClick: () => {
                inputParam_CustomOpenPanel && inputParam_CustomOpenPanel()
            },
        }
    ];

    useEffect(() => {
        if (showRequiredMessage === null || showRequiredMessage === true) {
            setMessageConfig(prevState => ({
                ...prevState,
                showMessage: true
            }));
        }
    }, [showRequiredMessage]);

    return <>
        {
            (inputParam_ExternalExportTemplates !== null || items.filter(x => x.hidden === false).length !== 0) &&
            <Row>
                {
                    (showRequiredMessage === null || showRequiredMessage === true) &&
                    <Col>
                        <Stack reversed horizontal={true} className='float-start'>
                            <Stack.Item order={2} className="stack-item-left">
                                    <MessageBox  
                                        inputParam_Width="100%" 
                                        inputParam_Message={ messageConfig.message }
                                        inputParam_Display={ messageConfig.showMessage }
                                        inputParam_MessageType={ messageConfig.messageType }
                                        inputParam_SetterMessage={ setMessageConfig }
                                    />
                            </Stack.Item>
                        </Stack>
                    </Col>
                }
                <Col>
                    <Stack horizontal={true} className='float-end'>
                        <Stack.Item order={2} >
                            {
                                inputParam_Configuration.buttons.showDownloadTemplate ?
                                <CommandButton
                                    className='ms-auto'
                                    menuProps={{
                                        items: inputParam_ExternalExportTemplates,
                                        directionalHintFixed: true,
                                    }}
                                    iconProps={{ iconName: 'Download' }}
                                    text={ t('data-lang-btn-downloadtemplate') }
                                    ariaLabel={ t('data-lang-btn-downloadtemplate') }
                                /> :
                                <CommandBar className='ms-auto' items={itemsExportTemplate} />
                            }
                        </Stack.Item>
                        <Stack.Item order={1}>
                            <CommandBar
                                className='ms-auto'
                                items={!inputParam_Configuration.buttons.groupedButtons ? items : undefined}
                                overflowItems={inputParam_Configuration.buttons.groupedButtons ? items : undefined}
                            />
                        </Stack.Item>
                    </Stack>
                </Col>
            </Row>  
        }
    </>;
};

MatrixToolbar.propTypes = {
    inputParam_HandleUploadData: PropTypes.func.isRequired,
    inputParam_HandleExportData: PropTypes.func.isRequired,
    inputParam_HandleSaveData: PropTypes.func.isRequired,
    inputParam_HandleAddRow: PropTypes.func.isRequired,
    inputParam_Configuration: PropTypes.object.isRequired,
};

export default MatrixToolbar;